import { render, staticRenderFns } from "./LuckyCoin.vue?vue&type=template&id=161558b2&scoped=true&"
import script from "./LuckyCoin.vue?vue&type=script&lang=ts&"
export * from "./LuckyCoin.vue?vue&type=script&lang=ts&"
import style0 from "./lucky_coin.scss?vue&type=style&index=0&id=161558b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161558b2",
  null
  
)

export default component.exports